// Screen `instance` — Settings › Installation (license and updates; instance operators) — owner: S11.
import { createFileRoute } from '@tanstack/react-router';
import { InstancePage } from '../../../features/ops/InstancePage';

export const Route = createFileRoute('/_settings/settings/instance')({
  component: InstancePage,
});
